import React, { createContext, useContext, useReducer } from 'react';
import { agreementsReducer, initialState, IAgreementsState, Action } from './agreements-reducer';

const AgreementsStateContext = createContext<IAgreementsState | undefined>(undefined);
const AgreementsDispatchContext = createContext<React.Dispatch<Action> | undefined>(undefined);

export const AgreementsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [state, dispatch] = useReducer(agreementsReducer, initialState);

    return (
        <AgreementsStateContext.Provider value={state}>
            <AgreementsDispatchContext.Provider value={dispatch}>
                {children}
            </AgreementsDispatchContext.Provider>
        </AgreementsStateContext.Provider>
    );
};

export const useAgreementsState = (): IAgreementsState => {
    const context = useContext(AgreementsStateContext);
    if (!context) {
        throw new Error('useAgreementsState must be used within AgreementsProvider');
    }
    return context;
};

export const useAgreementsDispatch = (): React.Dispatch<Action> => {
    const context = useContext(AgreementsDispatchContext);
    if (!context) {
        throw new Error('useAgreementsDispatch must be used within AgreementsProvider');
    }
    return context;
};
